export const GAMEPLAY_HYBRID_IMAGES: { [key: string]: string } = {
  ludoCenterBg: 'ludo-center-bg',
  grWaiting: 'gr_waiting',
  defaultAvatar: 'default-avatar',
  bgTimer: 'bg_timer',
  plcholderGlow: 'plcholder_glow',
  dicePlcholderLeft: 'dice__dice-placeholder-left',
  dicePlcholderRight: 'dice__dice-placeholder-right',
  defaultDiceGreen: 'dice__default-dice-green',
  defaultDiceRed: 'dice__default-dice-red',
  kingDice: 'dice__king-dice',
  dice1: 'dice__dice-1',
  dice2: 'dice__dice-2',
  dice3: 'dice__dice-3',
  dice4: 'dice__dice-4',
  dice5: 'dice__dice-5',
  dice6: 'dice__dice-6',
  destinyYellow: 'destiny__yellow',
  destinyRed: 'destiny__red',
  destinyGreen: 'destiny__green',
  bgGameplayPrizepot: 'bg_gameplay_pricepot',
  bgGameplayTopMessage: 'bg_gameplay_top_message',
  icClock: 'ic_clock',
  infoIcon: 'info_icon',
  bgGameplayStartText: 'bg_gameplay_start_text',
  cross: 'cross',
  user_stats: 'user_stats',
  gr_prize_small: 'gr_prize_small',
  gr_thumb_small: 'gr_thumb_small',
  ic_common: 'ic_common',
  prizeDistrubutionBg: 'prizeDistrubution-bg',
  leftTag: 'left_tag',
  chalaGayaTag: 'chalagaya_tag',
  result_winner: 'crown',
  result_rank: 'medal',
  result_tie: 'tie',
  result_looser: 'dice_saturn',
  bgScoreGlow: 'bg_score_glow',
  path3Player: 'path_3_player',
  pathBorder3Player: 'path_border_3_player',
  pathBg3Player: 'path_bg_3_player',
  prizeDistributionIcon: 'prize_distribution_icon',
  blue_sunburst: 'blue_sunburst',
  blue_sunburst_2p4p: 'blue_sunburst_2p4p',
  stable_internet: 'stable_internet',
  weak_internet: 'weak_internet',
  no_internet: 'no_internet',
  board_2_4_player: 'board_2_4_player',
  prizePoolTrophy: 'prize_pool_trophy',
  dice_default: 'ic_dice_default',
  dice2P_1: 'dice2P_1',
  dice2P_2: 'dice2P_2',
  dice2P_3: 'dice2P_3',
  dice2P_4: 'dice2P_4',
  dice2P_5: 'dice2P_5',
  dice2P_6: 'dice2P_6',
  crossNewDesign: 'cross_new_design',
  thumbsDown: 'thumbs_down',
  tokenGraphics: 'token_graphics',
  ludoboardCenterNudge: 'ludoboard_center_nudge',
  clockNewNormal: 'clock_new_normal',
  winnerCrown: 'winner_crown',
  winnerScreenBackground: 'winnerscreen_bg',
  winnerScreenPrizeDistribution: 'winnerscreen_prize_distribution',
  winnerScreenLoose: 'winnerScreen_loose',
  winnerScreenTie: 'winnerScreen_tie',
  winnerScreenCoin: 'winnerScreen_coin',
  handPointing: 'hand_pointing',
  handPointingLudonx: 'hand_pointing_ludonx',
  nudgeGradientBackground: 'nudge_gradient_background',
  gameplayHorizontalNudge: 'gameplay_horizontal_nudge',
  lb24SkipBg: 'lb_2_4_skip_bg',
  shutterstock: 'shutterstock',
  winnerScreenTokenClash: 'winnerScreen_tokenClash',
  nxBgPattern: 'nx_bg_pattern',
  ludonxThumbsUp: 'winnerscreen_ludonx_thumbsUp',
  ludonxSunburstAndStars: 'winnerscreen_ludonx_sunburstAndStars',
  ludonxMoneyBag: 'winnerscreen_ludonx_moneyBag',
  ludonxClock: 'winnerscreen_ludonx_clock'
}


export const GAMEPLAY_ANIMATION_IMAGES: { [key: string]: string } = {
  lbStartThumbsUp: require('../assets/images/gameplay/thumbs-up-icon.svg').default,
  hexagonShape: require('../assets/hexagon-shape-icon.svg').default,
  // diceLoader: require('./gameplay/dice-loader.png') as string,
  // smokeYellow: require('./gameplay/smoke/yellow.png') as string,
  // smokeBlue: require('./gameplay/smoke/blue.png') as string,
  // smokeRed: require('./gameplay/smoke/red.png') as string,
  // smokeGreen: require('./gameplay/smoke/green.png') as string,
  // figurineYellow: require('./gameplay/figurine/yellow.png') as string,
  // figurineRed: require('./gameplay/figurine/red.png') as string,
  // figurineGreen: require('./gameplay/figurine/green.png') as string,
  // glowYellow: require('./gameplay/movingKukariGlow/yellow.png') as string,
  // glowBlue: require('./gameplay/movingKukariGlow/blue.png') as string,
  // glowRed: require('./gameplay/movingKukariGlow/red.png') as string,
  // glowGreen: require('./gameplay/movingKukariGlow/green.png') as string,
  // diceGlow: require('./gameplay/dice_glow.png') as string,
  // startEn: require('./gameplay/start_en.png') as string,
  // startHi: require('./gameplay/start_hi.png') as string,
  // skipEn: require('./gameplay/skip_en.png') as string,
  // skipHi: require('./gameplay/skip_hi.png') as string,
  // coin: require('./gameplay/coin.png') as string,
  // hand: require('./gameplay/hand.png') as string,
  // figurine_2_4__blue: require('./gameplay/figurine_2_4_player/blue.png') as string,
  // figurine_2_4__green: require('./gameplay/figurine_2_4_player/green.png') as string,
  // figurine_2_4__red: require('./gameplay/figurine_2_4_player/red.png') as string,
  // figurine_2_4__yellow: require('./gameplay/figurine_2_4_player/yellow.png') as string,
  // gameplayCenterNudge: require('./gameplay/ludoboard_center_nudge.png') as string,
  // lbBgStartNudge: require('./gameplay/lb_bg_start_nudge.png') as string,
  // lbNudgeBgEclipse: require('./gameplay/lb_nudge_bg_eclipse.png') as string,
  // lbNudgeBgDarkCircle: require('./gameplay/lb_nudge_bg_dark_circle.png') as string,
  // startNew: require('./gameplay/start_new.png') as string,
  // turnSkipNew: require('./gameplay/turn_skip_new.png') as string,
  // lbSkipTripleSix: require('./gameplay/lb_skip_triple_six.png') as string,
  // red_56: require('./gameplay/home/red_56.png') as string,
  // blue_56: require('./gameplay/home/blue_56.png') as string,
  // green_56: require('./gameplay/home/green_56.png') as string,
  // crosshair: require('./gameplay/crosshair.png') as string,
  // safeHighlightRays: require('./gameplay/safeHighlightRays.png') as string,
  // homeHighlightBox: require('./gameplay/homeHighlightBox.png') as string,
  // homeHighlightTriangle: require('./gameplay/homeHighlightTriangle.png') as string,
  // red_43_en: require('./gameplay/home/red_43_en.png') as string,
  // green_43_en: require('./gameplay/home/green_43_en.png') as string,
  // red_43_hi: require('./gameplay/home/red_43_hi.png') as string,
  // green_43_hi: require('./gameplay/home/green_43_hi.png') as string
}